function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBelfastCabTourPaymentMethod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 508 508",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7BB83"
    },
    d: "M496,240.5c0,8.8-7.2,16-16,16H144c-8.8,0-16-7.2-16-16V32.7c0-8.8,7.2-16,16-16h336 c8.8,0,16,7.2,16,16V240.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6E4123"
    },
    d: "M480,268.5H144c-15.4,0-28-12.6-28-28V32.7c0-15.4,12.6-28,28-28h336c15.4,0,28,12.6,28,28v207.8 C508,255.9,495.4,268.5,480,268.5z M144,28.7c-2.2,0-4,1.8-4,4v207.8c0,2.2,1.8,4,4,4h336c2.2,0,4-1.8,4-4V32.7c0-2.2-1.8-4-4-4 H144z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 52.7,
    style: {
      fill: "#6E4123"
    },
    width: 372,
    height: 48
  })), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 120.7,
    style: {
      fill: "#F6E89A"
    },
    width: 204,
    height: 40
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6E4123"
    },
    d: "M472.5,169.2h-221v-57h221V169.2z M268.5,152.2h187v-23h-187V152.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B2EDA6"
    },
    points: "416,188.7 416,388.2 12,388.7 12,188.7 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C663E"
    },
    d: "M12,391.7c-0.8,0-1.6-0.3-2.1-0.9c-0.6-0.6-0.9-1.3-0.9-2.1v-200c0-1.7,1.3-3,3-3h404 c1.7,0,3,1.3,3,3v199.5c0,1.7-1.3,3-3,3L12,391.7L12,391.7z M15,191.7v194l398-0.5V191.7H15z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.5,
      fill: "#B8CBCD",
      enableBackground: "new"
    },
    cx: 266.7,
    cy: 456,
    rx: 190.7,
    ry: 47.3
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B2EDA6"
    },
    points: "464,240.7 464,440.2 64,440.7 64,240.7 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C663E"
    },
    d: "M64,449.2c-2.3,0-4.4-0.9-6-2.5s-2.5-3.8-2.5-6v-200c0-4.7,3.8-8.5,8.5-8.5h400 c4.7,0,8.5,3.8,8.5,8.5v199.5c0,4.7-3.8,8.5-8.5,8.5L64,449.2L64,449.2z M72.5,249.2v183l383-0.5V249.2H72.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#84C671"
    },
    cx: 250.2,
    cy: 338.4,
    r: 57.7
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C663E"
    },
    d: "M60,448.7c-3.2,0-6.2-1.3-8.5-3.5c-2.3-2.3-3.5-5.3-3.5-8.5v-36H12c-6.6,0-12-5.4-12-12v-200 c0-6.6,5.4-12,12-12h404c6.6,0,12,5.4,12,12v36h36c6.6,0,12,5.4,12,12v199.5c0,6.6-5.4,12-12,12L60,448.7L60,448.7z M24,376.7h36 c6.6,0,12,5.4,12,12v36l380-0.5V248.7h-36c-6.6,0-12-5.4-12-12v-36H24V376.7z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBelfastCabTourPaymentMethod);
export default __webpack_public_path__ + "static/media/belfast-cab-tour-payment-method.7e4e1431f36cf42fbcd3cd5fe7939e31.svg";
export { ForwardRef as ReactComponent };